// (B) 플레인 Row — antd Row 대체(순수 시각). antd 24-grid Row → flex(row wrap). `.om-row` 미러링.
// 소비처는 className(mainTop/mainRow/fromField 등)으로 레이아웃 정의 → 여기선 flex base(styles/omRow.css)만.
import type { OmwRowProps } from '../api/OmwRow'
import { cx } from './cx'
import '../styles/omwRow.css'

export function PlainRow({ className, style, children, 'data-testid': testid }: OmwRowProps) {
  return (
    <div className={cx('om-row', className)} style={style} data-testid={testid}>
      {children}
    </div>
  )
}
